import React from "react";

export const hasChildrenDeepProperty = (obj, prop, value) => {
    if (typeof obj === 'object' && obj !== null) {
        if (obj.hasOwnProperty(prop) && obj[prop] === value) {
            return obj;
        }
        for (const p in obj) {
            if(p === "props" || p === 'children') {
                if (obj.hasOwnProperty(p)) {
                    const own = hasChildrenDeepProperty(obj[p], prop, value);
                    if(own) {
                        return own;
                    }
                }
            }
        }
    }
    return null;
};

export const getDeepComponentsByProperty = (obj, prop, value) => {
    if (typeof obj === 'object' && obj !== null) {
        if (obj.hasOwnProperty(prop) && obj[prop] === value) {
            return [obj];
        }

        const checkNestedArray = (_obj) => {
            if(Array.isArray(_obj)) {
                for (let i = 0; i < _obj.length; i++) {
                    if(Array.isArray(_obj[i])) {
                        const nestedItems = checkNestedArray(_obj[i]);
                        if (nestedItems.length) return nestedItems
                    }

                    if (typeof _obj[i] === 'object' && _obj[i] !== null && _obj[i].hasOwnProperty(prop) && _obj[i][prop] === value) {
                        return [_obj[i]];
                    }
                }
            }

            return [];
        };

        const nestedCheckSpecificProp = (_obj, propName) => {
            if (typeof obj === 'object' && obj !== null && _obj.hasOwnProperty(propName)) {
                if(Array.isArray(_obj[propName])) {
                    const nestedItems = checkNestedArray(_obj[propName]);
                    if (nestedItems.length) return nestedItems
                }
                const own = getDeepComponentsByProperty(_obj[propName], prop, value);
                if(own.length) {
                    return own;
                }
            }
            return []
        };

        const checkSpecificProps = (_obj) => {
            const inProps = nestedCheckSpecificProp(_obj, 'props');
            if (inProps.length) return inProps;

            const inChildren = nestedCheckSpecificProp(_obj,'children');
            if (inChildren.length) return inChildren;

            return [];
        };

        if(Array.isArray(obj)) {
            const nestedItems = checkNestedArray(obj);
            if (nestedItems.length) return nestedItems
        }

        const results = checkSpecificProps(obj);
        if (results.length) return results;
    }
    return [];
};

export const itHasChildrenDeepProperty = (obj, prop, value) => {
    if (typeof obj === 'object' && obj !== null) {
        if (obj.hasOwnProperty(prop) && obj[prop] === value) {
            return true;
        }
        for (const p in obj) {
            if(p === "props" || p === 'children') {
                if (typeof obj === 'object' && obj.hasOwnProperty(p)) {
                    const own = getDeepComponentsByProperty(obj[p], prop, value);
                    if(own.length) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
};

export const modifyNestedChildren = ({children, excludedChildrens = [], type, additionalProps, beforeReturnCallback, onReturnCallback}) => {
    const prepareComponent = (child) => {
        if (Array.isArray(child)) {
            return prepareComponents(child)
        }
        if(child.type !== type && child.props && child.props.children) {
            return React.cloneElement(child, {}, prepareComponent(React.Children.toArray(child.props.children)))
        }

        const componentProps = typeof additionalProps === 'function' ? additionalProps(child) : additionalProps;

        const element = React.cloneElement(child, {
            ...componentProps
        });

        if (onReturnCallback) {
            onReturnCallback()
        }

        return element;
    };

    const prepareComponents = (children) => {
        return children.map((child) => {
            if (beforeReturnCallback) {
                beforeReturnCallback()
            }
            return prepareComponent(child);
        });
    };

    const getChildrenOriginalComponent = (children) => {
        return React.Children.toArray(children).filter((child) => {
            for (let i = 0; i < excludedChildrens.length; i++) {
                if (itHasChildrenDeepProperty(child, 'type', excludedChildrens[i])) {
                    return false
                }
            }

            return itHasChildrenDeepProperty(child, 'type', type)
        });
    };

    return prepareComponents(
        excludedChildrens.length ? getChildrenOriginalComponent(children) : children
    )
};
